import { useEffect, useState } from "react";
import "../../App.css";
import Header from "../../Components/Header/Header";
import LeftMenu from "../../Components/LeftMenu/LeftMenu";
import Chart from "react-apexcharts";
import Total_reg from "../../assets/images/total_regions.png";
import Total_vol from "../../assets/images/total_volume.png";
import Total_cun from "../../assets/images/total_countries.png";
import TopMenu from "../../Components/TopMenu/TopMenu";
import { withRFSToken } from "../../Services/axios";
import AssetsIconA from '../../assets/images/assets_a.svg';
import AssetsIcon from '../../assets/images/assets.svg';

const Kpicharts = () => {
  const getCurrentYear = new Date().getFullYear();
  const getCurrentMonth = new Date().getMonth() + 1;
  const [selectedCountry, setSelectedCountry] = useState("All Regions");
  // const [selectedMonth, setSelectedMonth] = useState(() => {
  //   const monthNames = ["january", "february", "march", "april", "may", "june",
  //     "july", "august", "september", "october", "november", "december"];
  //   return monthNames[getCurrentMonth - 1];
  // });
  const [selectedMonth, setSelectedMonth] = useState("august");
  const [apiData, setApiData] = useState(null);
  const [stats, setStats] = useState({
    totalRegions: 0,
    totalCountries: 0,
    totalVolume: 0
  });
  const [regionStatus, setRegionStatus] = useState(false);
  const [countryStatus, setCountryStatus] = useState(false);
  const [regionSeriesData, setRegionSeriesData] = useState([]);
  const [countryChartData, setCountryChartData] = useState([]);
  const [allRegion, setAllRegion] = useState([]);
  const [selectedRegionId, setSelectedRegionId] = useState(null);
  const [selectedButton, setSelectedButton] = useState("assets");

  const countryColors = ["#E91E63", "#00BCD4", "#9C27B0", "#4CAF50", "#2196F3", "#FF9800", "#795548", "#607D8B"];

  const handleChangeTabs = (tab) => {
    console.log("tabbbb", tab)
    setSelectedButton(tab)
    localStorage.setItem("tabStatus", tab)
  }

  const processApiData = (apiData) => {
    if (!apiData || !apiData?.periods) return [];
    const regionMap = {};
    const allPeriods = apiData?.periods?.map(p => p?.period);

    apiData?.periods?.forEach(period => {
      period?.data?.forEach(region => {
        if (!regionMap[region?.region_name]) {
          regionMap[region?.region_name] = {
            name: region?.region_name,
            data: Array(allPeriods?.length)?.fill(0),
            color: region?.colour_code,
            hasData: false,
          };
        }
        const weekIndex = allPeriods?.indexOf(period?.period);
        const volume = parseFloat(region?.total_volume) || 0;
        regionMap[region?.region_name].data[weekIndex] = volume;
        if (volume > 0) {
          regionMap[region.region_name].hasData = true;
        }
      });
    });
    return Object.values(regionMap);
  };

  const getFilteredData = () => {
    let filteredData = countryChartData;
    if (selectedCountry !== "All Regions") {
      filteredData = countryChartData.filter(
        (country) => country?.name === selectedCountry
      );
    }
    return filteredData.filter(series => series.data.some(value => value > 0));
  };


  const getMonthNumber = (monthName) => {
    const monthMap = {
      "january": 1,
      "february": 2,
      "march": 3,
      "april": 4,
      "may": 5,
      "june": 6,
      "july": 7,
      "august": 8,
      "september": 9,
      "october": 10,
      "november": 11,
      "december": 12
    };
    return monthMap[monthName?.toLowerCase()] || 1;
  };

  const fetchTotalVolumeByRegion = async (year, month) => {
    console.log("monthhhh", month)
    setRegionStatus(true);
    try {
      const res = await withRFSToken.post('kpi-chart/regions', {
        filter: "week",
        month: `${year}-${month}`
      });
      if (res?.data?.response_code === 200) {
        const innerData = res?.data?.response_data;
        setApiData(innerData);
        const processedData = processApiData(innerData);
        setRegionSeriesData(processedData);
        if (innerData && innerData?.overall_summary) {
          setStats({
            totalRegions: innerData?.overall_summary?.total_regions || 0,
            totalCountries: innerData?.overall_summary?.total_countries || 0,
            totalVolume: (innerData?.overall_summary?.total_volume)?.toFixed(0) || 0
          });
        }
      }
      setRegionStatus(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setRegionStatus(false);
    }
  };

  const fetchTotalVolumeByCountry = async (regionId) => {
    if (!regionId) return;

    setCountryStatus(true);
    try {
      const res = await withRFSToken.post('kpi-chart/get-region-booking-truck', {
        region: regionId,
        flt_type: "M",
      });

      if (res?.data?.response_code === 200) {
        const innerData = res.data.response_data
        const transformedData = innerData
          .map((item, index) => ({
            name: item.country,
            color: countryColors[index % countryColors.length],
            data: item.booking_trucks.map(booking => parseFloat(booking.total_volume) || 0),
            totalVolume: item.booking_trucks.reduce((acc, booking) => acc + (parseFloat(booking.total_volume) || 0), 0),
          }))
          .filter(item => item.totalVolume > 0);
        setCountryChartData(transformedData);
      }
      setCountryStatus(false);
    } catch (error) {
      console.error("Error fetching country data:", error);
      setCountryStatus(false);
    }
  };

  const fetchAllRegions = async () => {
    try {
      const res = await withRFSToken.post('kpi-chart/get-region-list', {});
      if (res?.data?.response_code === 200) {
        const innerData = res?.data?.response_data;
        setAllRegion(innerData);
        const defaultRegion = innerData?.find((region) => region?.value === 6);
        if (defaultRegion) {
          setSelectedCountry(defaultRegion?.label);
          setSelectedRegionId(6);
        }
        else if (innerData && innerData.length > 0) {
          setSelectedCountry(innerData[0]?.label || "All Regions");
          setSelectedRegionId(innerData[0]?.value);
        }
      }
    } catch (error) {
      console.error("Error fetching regions:", error);
    }
  };

  const getTotalVolumeByRegionCategories = () => {
    if (!apiData || !apiData?.periods) return [];
    return apiData?.periods?.map(period => period?.period);
  };

  const getTotalVolumeByRegionColors = () => {
    return regionSeriesData?.map(series => series?.color);
  };

  const totalVolumeByRegionOption = {
    chart: {
      type: "line",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: "smooth",
      width: 3,
    },
    colors: getTotalVolumeByRegionColors(),
    grid: {
      borderColor: "#f1f1f1",
      xaxis: { lines: { show: true } },
      yaxis: { lines: { show: true } },
    },
    markers: { size: 4, hover: { sizeOffset: 6 } },
    dataLabels: { enabled: false },
    xaxis: {
      categories: getTotalVolumeByRegionCategories(),
      labels: { style: { colors: "#304758" } },
      axisBorder: { show: true, color: "grey", height: 1, width: "100%" },
      axisTicks: { show: true, borderType: "solid", color: "grey", height: 6 },
    },
    yaxis: {
      min: 0,
      tickAmount: 4,
      labels: {
        style: { colors: "#304758" },
        formatter: function (val) {
          return Math.round(val);
        }
      },
      axisBorder: { show: true, color: "grey", width: 1 },
      axisTicks: {
        show: true,
        borderType: "solid",
        color: "grey",
        width: 1,
        height: 6,
      },
    },
    legend: {
      position: "bottom",
      showForSingleSeries: true,
      horizontalAlign: "center",
      markers: { width: 10, height: 10, radius: 12 },
      itemMargin: { horizontal: 10, vertical: 5 },
    },
    tooltip: {
      y: { formatter: (val) => `${Math.round(val)} m³` },
      shared: true,
      intersect: false,
    },
  };

  const totalVolumeByCountryOption = {
    chart: {
      type: "line",
      toolbar: { show: false },
      zoom: { enabled: false },
    },
    stroke: {
      curve: "smooth",
      width: 2,
    },
    colors: getFilteredData()?.map((d) => d?.color),
    grid: {
      borderColor: "#F3F4F6",
      strokeDashArray: 0,
      xaxis: {
        lines: { show: true },
      },
      yaxis: {
        lines: { show: true },
      },
    },
    markers: {
      size: 3,
      strokeWidth: 0,
      hover: { sizeOffset: 2 },
    },
    dataLabels: { enabled: false },
    xaxis: {
      categories: [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
      ],
      labels: {
        style: { colors: "#304758", fontSize: "11px" },
      },
      axisBorder: { show: true, color: "grey", height: 1, width: "100%" },
      axisTicks: { show: true, borderType: "solid", color: "grey", height: 6 },
    },
    yaxis: {
      min: 0,
      tickAmount: 4,
      labels: {
        style: { colors: "#304758", fontSize: "11px" },
        formatter: function (val) {
          return Math.round(val);
        }
      },
      axisBorder: { show: true, color: "grey", width: 1 },
      axisTicks: {
        show: true,
        borderType: "solid",
        color: "grey",
        width: 1,
        height: 6,
      },
    },
    legend: {
      position: "bottom",
      showForSingleSeries: true,
      horizontalAlign: "center",
      fontSize: "11px",
      markers: {
        width: 8,
        height: 8,
        radius: 0,
        strokeWidth: 0,
      },
      itemMargin: { horizontal: 10, vertical: 6 },
      labels: { colors: "#304758" },
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (val) => `${Math.round(val)} m³`,
      },
    },
  };

  const months = [
    { value: "january", label: "January" },
    { value: "february", label: "February" },
    { value: "march", label: "March" },
    { value: "april", label: "April" },
    { value: "may", label: "May" },
    { value: "june", label: "June" },
    { value: "july", label: "July" },
    { value: "august", label: "August" },
    { value: "september", label: "September" },
    { value: "october", label: "October" },
    { value: "november", label: "November" },
    { value: "december", label: "December" }
  ];

  const handleMonthChange = (e) => {
    const newMonth = e.target.value;
    setSelectedMonth(newMonth);
    const monthNum = getMonthNumber(newMonth);
    fetchTotalVolumeByRegion(getCurrentYear, monthNum);
  };

  const handleRegionChange = (e) => {
    const selectedLabel = e.target.value;
    setSelectedCountry(selectedLabel);
    const selectedRegion = allRegion.find(region => region?.label === selectedLabel);
    if (selectedRegion) {
      setSelectedRegionId(selectedRegion.value);
    }
  };

  useEffect(() => {
    const monthToUse = selectedMonth ? getMonthNumber(selectedMonth) : getCurrentMonth;
    fetchTotalVolumeByRegion(getCurrentYear, monthToUse)
  }, [])

  useEffect(() => {
    fetchAllRegions();
  }, []);

  useEffect(() => {
    if (selectedRegionId) {
      fetchTotalVolumeByCountry(selectedRegionId);
    }
  }, [selectedRegionId]);


  return (
    <>
      <div className="container-scroller dashboard">
        <Header logo_url='/Dashboard' />
        <div className="container-fluid d-flex p-0 page-body-wrapper">
          <LeftMenu />
          <div className="chart-panel main-panel rounded">
            <TopMenu />
            <div className="rounded">
              <div className="mb-3">
                <button onClick={() => handleChangeTabs("assets")} className={selectedButton === 'assets' ? 'exportbtn me-3 active' : 'exportbtn me-3'}>
                  <img src={selectedButton === 'assets' ? AssetsIconA : AssetsIcon} /> <span>Truck Schedule</span>
                </button>

                <button onClick={() => handleChangeTabs("truckerPerformance")} className={selectedButton === 'truckerPerformance' ? 'exportbtn me-3 active' : 'exportbtn me-3'}>
                  <img src={selectedButton === 'truckerPerformance' ? AssetsIconA : AssetsIcon} /> <span>Trucker Performance</span>
                </button>

                <button onClick={() => handleChangeTabs("handlerPerformance")} className={selectedButton === 'handlerPerformance' ? 'exportbtn me-3 active' : 'exportbtn me-3'}>
                  <img src={selectedButton === 'handlerPerformance' ? AssetsIconA : AssetsIcon} /> <span>Handler Performance</span>
                </button>
              </div>
              <div className="row rfs_chart">
                <div className="col-md-3 pe-0 mb-2">
                  <div
                    className="d-flex flex-column "
                    style={{ height: "100%" }}
                  >
                    <div className="cartbox mb-2 chart_height all_border">
                      <div className="d-flex gap-3 align-items-center justify-content-center">
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            width: "65px",
                            height: "65px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(59,130,246,0.1)",
                          }}
                        >
                          <img src={Total_reg} />
                        </div>
                        <div className="total_reg">
                          <p>
                            Total Regions
                          </p>
                          <h5 className="mb-0 fw-bold">{stats?.totalRegions}</h5>
                        </div>
                      </div>
                    </div>

                    <div className="cartbox mb-2 chart_height all_border">
                      <div className="d-flex gap-3 align-items-center justify-content-center">
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            width: "65px",
                            height: "65px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(59,130,246,0.1)",
                          }}
                        >
                          <img src={Total_cun} />
                        </div>
                        <div className="total_reg">
                          <p>
                            Total Countries
                          </p>
                          <h5 className="mb-0 fw-bold">{stats?.totalCountries}</h5>
                        </div>
                      </div>
                    </div>

                    <div className="cartbox chart_bd all_border">
                      <div className="d-flex align-items-center justify-content-center gap-3">
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            width: "65px",
                            height: "65px",
                            borderRadius: "50%",
                            backgroundColor: "rgba(59,130,246,0.1)",
                          }}
                        >
                          <img src={Total_vol} />
                        </div>
                        <div className="total_reg">
                          <p>
                            Total Volume
                          </p>
                          <h5 className="mb-0 fw-bold">{stats?.totalVolume} m3</h5>
                          <div className="mt-0">
                            <p
                              className="mb-0"
                              style={{ fontSize: "13px", color: "#9CA3AF" }}
                            >
                              ({selectedMonth})
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-9 mb-2">
                  <div className="cartbox all_border">
                    <div className="d-flex justify-content-between align-items-start mb-3 gap-2">
                      <div className="new_chart">
                        <h3>
                          Total Volume by Region
                        </h3>
                        <p>
                          Overview of shipment volumes across regions over time
                        </p>
                      </div>

                      <select
                        className="form-select form-select-sm"
                        style={{
                          width: "auto",
                          fontSize: "12px",
                          border: "1px solid #E5E7EB",
                          borderRadius: "6px",
                          padding: "6px 32px 6px 12px",
                          color: "#6B7280",
                          cursor: "pointer",
                        }}
                        value={selectedMonth}
                        onChange={handleMonthChange}
                      >
                        {months?.map(month => (
                          <option key={month?.value} value={month?.value}>
                            {month?.label}
                          </option>
                        ))}
                      </select>
                    </div>
                    {regionStatus ? (
                      <div style={{ height: "345px" }} className="d-flex justify-content-center align-items-center">
                        <div className="spinner-border text-primary"></div>
                      </div>
                    ) : (
                      <Chart
                        options={totalVolumeByRegionOption}
                        series={regionSeriesData?.filter(s => s?.hasData)}
                        type="line"
                        height={330}
                      />
                    )}
                  </div>
                </div>

                <div className="col-12">
                  <div
                    className="cartbox all_border mb-3"
                    style={{ borderRadius: "8px" }}
                  >
                    <div className="card-body">
                      <div className="d-flex justify-content-between align-items-start mb-3">
                        <div className="new_chart">
                          <h3>Total Volume by Country</h3>
                          <p>
                            Overview of shipment volumes across countries over time.
                          </p>
                        </div>
                        <select
                          className="form-select form-select-sm"
                          style={{
                            width: "auto",
                            fontSize: "12px",
                            border: "1px solid #E5E7EB",
                            borderRadius: "6px",
                            padding: "6px 32px 6px 12px",
                            color: "#6B7280",
                            cursor: "pointer",
                          }}
                          value={selectedCountry}
                          onChange={handleRegionChange}
                        >
                          {allRegion?.map((region) => (
                            <option key={region?.value} value={region?.label}>
                              {region?.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div style={{ height: "400px" }}>
                        {countryStatus ? (
                          <div className="d-flex justify-content-center align-items-center h-100">
                            <div className="spinner-border text-primary"></div>
                          </div>
                        ) : (
                          <Chart
                            options={totalVolumeByCountryOption}
                            series={countryChartData}
                            type="line"
                            height={400}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Kpicharts;